export const NEW_CONTENT_AVAILABLE = "NEW_CONTENT_AVAILABLE"